import { type Pagination, type PaginationData, type UserList, createUserList } from 'models';
import { useInfiniteQuery } from 'query';
import type { ApiClientResponseError, DefaultResponseErrorDataObject } from 'common/services';
import type { GroupUsersFilter } from '../models';
import { getGroupUsers } from '../services';
import { getGroupUsersInfiniteQueryKey } from './keys';

type P = {
  filter: GroupUsersFilter;
  pagination: Omit<Pagination, 'position'>;
};

export const useGroupUsersInfiniteQuery = ({ filter, pagination }: P) =>
  useInfiniteQuery<
    PaginationData<UserList>,
    string | undefined,
    ApiClientResponseError<DefaultResponseErrorDataObject>
  >({
    async queryFn({ pageParam: cursor }) {
      const { data } = await getGroupUsers({
        config: {
          params: {
            cursor,
            limit: pagination.pageSize,
          },
        },
        routeParams: {
          id: filter.groupId,
        },
      });

      return { data: data.data.map((user) => createUserList(user)), total: data.total };
    },
    initialPageParam: undefined,
    getNextPageParam(lastPage, allPages) {
      if (allPages.length * pagination.pageSize >= lastPage.total) {
        return undefined;
      }

      return lastPage.data.at(-1)?.id;
    },
    queryKey: getGroupUsersInfiniteQueryKey({ filter, pagination }),
  });
